import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonIcon, IonSkeletonText } from '@ionic/angular/standalone';
import { FaceId } from 'libs/common/src/modules/face-id/model/face-id.model';
import { FaceIdRepository } from '../../modules/face-id';
import { Observable } from 'rxjs';
import { ImageUtil } from '@qid/core';

@Component({
  selector: 'mock-id-card',
  templateUrl: './mock-id-card.component.html',
  styleUrl: './mock-id-card.component.scss',
  standalone: true,
  imports: [CommonModule, IonIcon, IonSkeletonText],
})
export class MockIdCardComponent {

  @Input() fullName;

  public faceId: FaceId = this.faceIdRepository.faceId;
  public ImageUtil = ImageUtil;

  constructor(private faceIdRepository: FaceIdRepository) {

  }

}
